import { Logger } from "../logging";

export const catchErrors = (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
	const method = descriptor.value;
	descriptor.value = function(...args: any) {
		try {
			return method.apply(target, args);
		}
		catch (ex) {
			Logger.logException(`[Swallow:Exception] ${target.constructor.name}.${propertyKey}`, ex)
		}
	}
}